var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from '@xstyled/styled-components';
export var FooterRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 15px;\n  line-height: 23px;\n  opacity: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 15px;\n  line-height: 23px;\n  opacity: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.2 : 1);
});
var templateObject_1;
